import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import { APP_URL } from '../config';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;

  const logo = (
    <Box sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 106 78">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="">
          <path
            fill="#FFFFFE"
            opacity="1.000000"
            stroke="none"
            d="
M1.000000,24.000080 
	C1.000000,16.010307 1.000000,8.520510 1.000000,1.015357 
	C36.275021,1.015357 71.550049,1.015357 106.912537,1.015357 
	C106.912537,26.906055 106.912537,52.812508 106.912537,78.859482 
	C71.667084,78.859482 36.333614,78.859482 1.000000,78.859482 
	C1.000000,60.783974 1.000000,42.642017 1.000000,24.000080 
M101.662804,71.102394 
	C101.685173,52.442268 101.723129,33.782139 101.723190,15.122011 
	C101.723221,6.074990 98.793121,3.166641 89.762886,3.163967 
	C64.271126,3.156419 38.779362,3.159682 13.287601,3.158697 
	C11.667943,3.158635 10.048286,3.158689 8.122479,3.158689 
	C8.122479,10.772738 8.122479,17.887739 7.980220,25.893164 
	C8.027933,28.594595 8.075645,31.296028 7.973408,34.924568 
	C8.022238,47.289577 8.071068,59.654583 8.027745,72.505081 
	C8.027745,72.505081 8.240732,72.950989 8.688971,73.620682 
	C22.831129,73.662506 36.973385,73.757637 51.115421,73.732147 
	C67.415802,73.702759 83.715988,73.566872 100.546288,73.643188 
	C100.850105,73.101578 101.153923,72.559975 101.662804,71.102394 
z"
          />
          <path
            fill="#F7BC0B"
            opacity="1.000000"
            stroke="none"
            d="
M8.122479,25.002743 
	C8.122479,17.887739 8.122479,10.772738 8.122479,3.158689 
	C10.048286,3.158689 11.667943,3.158635 13.287601,3.158697 
	C38.779362,3.159682 64.271126,3.156419 89.762886,3.163967 
	C98.793121,3.166641 101.723221,6.074990 101.723190,15.122011 
	C101.723129,33.782139 101.685173,52.442268 101.336914,71.606705 
	C100.679443,72.566422 100.347855,73.021828 100.016258,73.477234 
	C83.715988,73.566872 67.415802,73.702759 51.115421,73.732147 
	C36.973385,73.757637 22.831129,73.662506 8.593578,73.183189 
	C8.637937,72.396881 8.511840,72.154846 8.119898,72.019592 
	C8.071068,59.654583 8.022238,47.289577 8.440871,34.462784 
	C12.820525,33.919132 13.978070,36.120358 14.055423,39.694832 
	C14.137025,43.465679 14.664591,47.226875 14.932586,51.403267 
	C15.929303,53.216751 16.990761,54.619259 18.052217,56.021770 
	C18.940067,57.731991 18.821913,59.887302 19.004292,62.016872 
	C19.067944,62.760117 19.872902,63.439877 20.339319,64.148628 
	C20.914276,63.380386 21.847473,62.671833 21.987549,61.831131 
	C22.256237,60.218563 21.745792,58.430099 22.210556,56.914547 
	C22.465704,56.082520 24.049784,55.658024 25.011627,55.032089 
	C24.988592,55.014404 24.962427,54.962547 24.956995,55.345078 
	C22.531620,61.009937 26.025810,63.395370 29.703768,65.574753 
	C31.085178,64.990234 32.401115,64.433426 34.118958,63.905846 
	C35.317356,64.048828 36.113857,64.162575 37.041374,64.623344 
	C40.056408,65.648453 42.940426,66.326553 45.987564,67.319092 
	C47.403809,66.411743 48.656933,65.189949 50.294308,63.979393 
	C51.446693,63.997005 52.214825,64.003365 53.177380,64.345886 
	C57.139458,65.405418 60.899094,66.181015 64.688469,66.763008 
	C65.028549,66.815247 65.561050,65.614685 66.353233,65.028030 
	C69.111519,64.634338 71.520767,64.208557 74.107056,63.491692 
	C75.037331,62.943249 76.236115,62.250095 76.475739,62.495087 
	C79.257378,65.339035 81.985573,65.395386 84.982788,62.846100 
	C85.343353,62.539417 86.317413,62.954021 87.003494,63.016430 
	C86.999863,62.998539 86.963524,62.994972 87.032913,63.334824 
	C88.587524,64.035133 90.072754,64.395584 91.944321,64.796982 
	C97.285553,62.712528 93.262657,58.876030 94.111969,55.707890 
	C93.808174,54.976616 93.416786,54.488903 92.911453,53.781021 
	C92.591682,53.286884 92.325340,53.098431 92.042519,52.623291 
	C95.550346,45.917530 94.412766,44.056698 87.042015,44.001343 
	C86.392052,43.996464 85.742020,43.999580 84.973091,43.628082 
	C81.652199,24.370625 67.260651,11.516814 48.850723,9.291666 
	C47.198849,8.617346 45.676903,8.065607 44.146717,8.041725 
	C37.767395,7.942162 31.385595,8.001388 24.589289,8.001606 
	C21.089142,7.814032 17.416008,7.817404 17.649784,11.761697 
	C17.740307,13.289050 21.627279,14.604733 23.810659,15.975538 
	C24.047688,16.124355 24.457520,15.997940 24.861778,16.411543 
	C24.903833,18.217484 24.871307,19.611073 24.474045,21.009388 
	C19.301046,24.430601 13.985922,25.815533 8.122479,25.002743 
M100.580490,69.517250 
	C100.580490,69.517250 100.470421,69.584290 100.580490,69.517250 
z"
          />
          <path
            fill="#FABF08"
            opacity="1.000000"
            stroke="none"
            d="
M8.051350,25.447952 
	C13.985922,25.815533 19.301046,24.430601 24.718220,21.366085 
	C28.088322,21.869492 30.849512,22.020933 34.052799,22.196621 
	C34.052799,31.253321 34.052799,40.027878 34.229542,49.110153 
	C35.314541,49.641071 36.222801,49.864277 37.048172,50.489166 
	C36.880287,52.254715 36.795292,53.618572 36.367950,54.997684 
	C35.570946,55.058895 35.116283,55.104847 34.305313,55.012939 
	C30.953474,54.904232 27.957951,54.933392 24.962427,54.962547 
	C24.962427,54.962547 24.988592,55.014404 25.076813,54.624977 
	C25.497683,53.281765 25.830330,52.327984 26.296177,50.992290 
	C22.129368,50.992290 18.563347,50.992290 14.997326,50.992290 
	C14.664591,47.226875 14.137025,43.465679 14.055423,39.694832 
	C13.978070,36.120358 12.820525,33.919132 8.515846,33.999229 
	C8.075645,31.296028 8.027933,28.594595 8.051350,25.447952 
z"
          />
          <path
            fill="#FAB503"
            opacity="1.000000"
            stroke="none"
            d="
M100.281273,73.560211 
	C100.347855,73.021828 100.679443,72.566422 101.234383,72.064682 
	C101.153923,72.559975 100.850105,73.101578 100.281273,73.560211 
z"
          />
          <path
            fill="#FAB503"
            opacity="1.000000"
            stroke="none"
            d="
M8.073822,72.262337 
	C8.511840,72.154846 8.637937,72.396881 8.369459,72.848343 
	C8.240732,72.950989 8.027745,72.505081 8.073822,72.262337 
z"
          />
          <path
            fill="#080602"
            opacity="1.000000"
            stroke="none"
            d="
M34.052799,48.802437 
	C34.052799,40.027878 34.052799,31.253321 34.052799,22.196621 
	C30.849512,22.020933 28.088322,21.869492 25.082956,21.361355 
	C24.871307,19.611073 24.903833,18.217484 24.934803,15.984880 
	C24.951048,13.413881 24.968853,11.681898 25.450068,9.867850 
	C33.601273,9.742861 41.289066,9.699935 48.976860,9.657009 
	C67.260651,11.516814 81.652199,24.370625 84.914391,44.022545 
	C84.904846,49.273708 84.660805,49.527634 80.982773,48.572044 
	C80.144798,31.687160 67.965202,16.466869 54.856785,16.203802 
	C58.473347,18.941824 62.770451,20.848288 66.077576,23.846663 
	C69.568176,27.011374 72.902817,30.853485 74.850792,35.071522 
	C76.782349,39.254005 76.901337,44.273560 77.512794,48.903790 
	C76.143082,48.920338 75.075874,48.959084 74.060837,48.574780 
	C73.068604,32.021900 57.923336,17.798668 44.497871,22.519356 
	C60.135437,25.695635 70.944908,32.330486 70.487457,48.905582 
	C69.222496,48.867226 68.301987,48.855892 67.298096,48.440689 
	C66.020912,35.394402 55.150707,25.515751 44.425449,29.581512 
	C56.069847,32.061260 64.532585,36.468937 63.529640,48.910324 
	C62.280365,48.865772 61.371101,48.851395 60.370808,48.449993 
	C59.009815,39.484154 53.896503,34.647560 45.671040,35.744457 
	C51.305878,39.279427 58.530537,40.813557 56.883030,48.912796 
	C56.924942,48.937103 56.948334,48.843063 56.575253,48.800755 
	C55.452686,48.777740 54.703205,48.797031 53.854671,48.652344 
	C53.585720,48.291851 53.382763,48.139317 53.145592,47.692963 
	C52.786121,46.842361 52.427814,46.329563 51.941101,45.504234 
	C49.970272,44.651543 49.303432,39.946198 46.491520,43.024349 
	C47.778366,45.195938 48.856636,47.015556 49.474579,48.863358 
	C44.027100,48.861839 39.039948,48.832142 34.052799,48.802437 
z"
          />
          <path
            fill="#F4BC08"
            opacity="1.000000"
            stroke="none"
            d="
M74.008659,48.997833 
	C75.075874,48.959084 76.143082,48.920338 77.901505,48.924469 
	C79.371384,48.977455 80.150047,48.987568 80.928711,48.997677 
	C84.660805,49.527634 84.904846,49.273708 85.033318,44.393440 
	C85.742020,43.999580 86.392052,43.996464 87.042015,44.001343 
	C94.412766,44.056698 95.550346,45.917530 91.689178,52.631187 
	C90.527756,53.674236 89.763725,54.337193 88.999847,55.000076 
	C89.000000,55.000000 89.000305,54.999847 88.669510,55.139290 
	C87.409882,55.364262 85.966553,55.875278 85.631302,55.469902 
	C82.048996,51.138325 78.415306,52.780960 74.521126,55.126774 
	C74.333626,55.120129 73.959694,55.153000 73.736519,54.982712 
	C73.333221,54.863213 73.153091,54.914001 72.993858,54.975971 
	C73.014748,54.987148 73.055481,55.011372 72.909515,54.645813 
	C71.202499,54.233540 69.641464,54.186821 67.935120,53.931404 
	C67.424232,54.355408 67.184822,55.148705 66.651413,55.567841 
	C66.255043,55.879307 65.477417,55.705574 64.923027,55.387939 
	C60.562794,53.265762 58.130455,54.754227 56.560722,60.049309 
	C56.555801,60.716724 56.844318,61.333168 57.464996,62.121311 
	C58.660660,62.948200 59.524162,63.603386 59.817333,63.825829 
	C61.034813,61.220169 62.022911,59.105431 63.009254,57.374344 
	C64.006401,60.170647 65.005295,62.583294 66.004189,64.995941 
	C65.561050,65.614685 65.028549,66.815247 64.688469,66.763008 
	C60.899094,66.181015 57.139458,65.405418 53.124893,63.989769 
	C51.867352,62.883942 50.856709,62.470379 49.517456,61.929565 
	C49.392757,59.590023 49.596664,57.377739 49.827553,54.872726 
	C49.081703,54.770721 47.482407,54.551994 45.824444,54.325245 
	C45.824444,58.726231 45.824444,62.865437 45.824444,67.004646 
	C42.940426,66.326553 40.056408,65.648453 37.069504,64.563629 
	C36.966614,64.156906 36.973351,64.027718 37.342087,64.102448 
	C38.457626,64.114845 39.204426,64.052513 40.240105,63.994270 
	C40.721386,63.989658 40.913792,63.980953 41.550457,64.048447 
	C42.756870,63.372807 44.111336,62.665783 44.172241,61.860882 
	C44.370117,59.245827 44.094448,56.594944 43.972664,53.652531 
	C44.330708,52.531643 44.502621,51.368919 45.146996,50.970688 
	C46.620213,50.060223 48.324482,49.523621 49.934910,48.835171 
	C48.856636,47.015556 47.778366,45.195938 46.491520,43.024349 
	C49.303432,39.946198 49.970272,44.651543 51.945862,45.837013 
	C52.434944,46.998463 52.790852,47.514610 53.146759,48.030762 
	C53.382763,48.139317 53.585720,48.291851 54.026371,48.932953 
	C55.180859,49.199383 56.064594,49.021221 56.948334,48.843063 
	C56.948334,48.843063 56.924942,48.937103 57.335922,48.945961 
	C58.651878,48.915550 59.556854,48.876282 60.461834,48.837017 
	C61.371101,48.851395 62.280365,48.865772 63.968765,48.927505 
	C65.625755,48.931427 66.503616,48.887993 67.381470,48.844555 
	C68.301987,48.855892 69.222496,48.867226 70.884148,48.925385 
	C72.419739,48.980747 73.214203,48.989292 74.008659,48.997833 
z"
          />
          <path
            fill="#EEC506"
            opacity="1.000000"
            stroke="none"
            d="
M74.708626,55.133419 
	C78.415306,52.780960 82.048996,51.138325 85.631302,55.469902 
	C85.966553,55.875278 87.409882,55.364262 88.706802,55.423164 
	C89.379219,55.890476 89.683563,56.213348 89.987907,56.536224 
	C90.168724,56.325638 90.349533,56.115059 90.530350,55.904476 
	C90.020134,55.603035 89.509911,55.301594 88.999695,55.000153 
	C89.763725,54.337193 90.527756,53.674236 91.645126,53.003384 
	C92.325340,53.098431 92.591682,53.286884 92.813332,54.029633 
	C93.227554,54.982761 93.625969,55.467106 94.024376,55.951450 
	C93.262657,58.876030 97.285553,62.712528 92.219276,64.534172 
	C92.234383,64.124771 92.383492,64.036156 92.480110,63.907982 
	C92.555450,63.808048 92.565529,63.658916 92.604607,63.531647 
	C90.724243,63.352753 88.843887,63.173862 86.963524,62.994972 
	C86.963524,62.994972 86.999863,62.998539 87.323013,62.731659 
	C85.244240,59.407932 82.296875,57.523022 77.896454,58.050522 
	C77.152832,58.014870 76.727898,58.004219 76.191406,57.680946 
	C75.622772,56.623356 75.165695,55.878387 74.708626,55.133419 
z"
          />
          <path
            fill="#140F03"
            opacity="1.000000"
            stroke="none"
            d="
M24.956995,55.345078 
	C27.957951,54.933392 30.953474,54.904232 34.445015,55.384872 
	C35.373669,57.055332 35.806297,58.215996 36.362274,59.707569 
	C33.150597,59.880432 30.512505,60.022427 27.874413,60.164417 
	C27.907358,60.675621 27.940304,61.186829 27.973249,61.698032 
	C30.360706,61.532635 32.748165,61.367237 35.702763,61.162548 
	C34.821316,62.367313 34.269184,63.121967 33.717056,63.876617 
	C32.401115,64.433426 31.085178,64.990234 29.703768,65.574753 
	C26.025810,63.395370 22.531620,61.009937 24.956995,55.345078 
z"
          />
          <path
            fill="#140F02"
            opacity="1.000000"
            stroke="none"
            d="
M14.932585,51.403267 
	C18.563347,50.992290 22.129368,50.992290 26.296177,50.992290 
	C25.830330,52.327984 25.497683,53.281765 25.099848,54.642662 
	C24.049784,55.658024 22.465704,56.082520 22.210556,56.914547 
	C21.745792,58.430099 22.256237,60.218563 21.987549,61.831131 
	C21.847473,62.671833 20.914276,63.380386 20.339319,64.148628 
	C19.872902,63.439877 19.067944,62.760117 19.004292,62.016872 
	C18.821913,59.887302 18.940067,57.731991 18.052217,56.021770 
	C16.990761,54.619259 15.929303,53.216751 14.932585,51.403267 
z"
          />
          <path
            fill="#ECC707"
            opacity="1.000000"
            stroke="none"
            d="
M66.353233,65.028030 
	C65.005295,62.583294 64.006401,60.170647 63.228836,57.195961 
	C63.923317,56.338604 64.396461,56.043282 64.869606,55.747955 
	C65.477417,55.705574 66.255043,55.879307 66.651413,55.567841 
	C67.184822,55.148705 67.424232,54.355408 68.126854,54.286743 
	C69.994415,54.904308 71.524948,54.957840 73.055481,55.011372 
	C73.055481,55.011372 73.014748,54.987148 72.792404,55.242676 
	C72.718735,55.664154 72.867401,55.830109 73.130493,56.248478 
	C73.484680,56.975842 73.724449,57.450787 73.523674,57.990383 
	C70.694626,58.055031 68.306129,58.055031 65.917633,58.055031 
	C65.915901,58.567966 65.914177,59.080906 65.912445,59.593842 
	C66.942513,59.769035 67.972588,59.944225 69.065796,60.454140 
	C70.333412,61.176147 71.537888,61.563435 72.649055,62.266376 
	C73.013840,62.982277 73.471924,63.382526 73.930008,63.782776 
	C71.520767,64.208557 69.111519,64.634338 66.353233,65.028030 
z"
          />
          <path
            fill="#261C05"
            opacity="1.000000"
            stroke="none"
            d="
M74.107056,63.491692 
	C73.471924,63.382526 73.013840,62.982277 72.973923,62.141731 
	C74.261208,61.503994 75.130318,61.306553 76.384781,61.107403 
	C77.251801,60.095642 77.733467,59.085587 78.215134,58.075527 
	C82.296875,57.523022 85.244240,59.407932 87.326645,62.749550 
	C86.317413,62.954021 85.343353,62.539417 84.982788,62.846100 
	C81.985573,65.395386 79.257378,65.339035 76.475739,62.495087 
	C76.236115,62.250095 75.037331,62.943249 74.107056,63.491692 
z"
          />
          <path
            fill="#FABF08"
            opacity="1.000000"
            stroke="none"
            d="
M24.986656,9.949914 
	C24.968853,11.681898 24.951048,13.413881 24.860220,15.572527 
	C24.457520,15.997940 24.047688,16.124355 23.810659,15.975538 
	C21.627279,14.604733 17.740307,13.289050 17.649784,11.761697 
	C17.416008,7.817404 21.089142,7.814032 24.590286,8.326244 
	C25.000019,9.084411 24.993338,9.517162 24.986656,9.949914 
z"
          />
          <path
            fill="#FECD08"
            opacity="1.000000"
            stroke="none"
            d="
M25.450066,9.867850 
	C24.993338,9.517162 25.000019,9.084411 25.005701,8.327021 
	C31.385595,8.001388 37.767395,7.942162 44.146717,8.041725 
	C45.676903,8.065607 47.198849,8.617346 48.850723,9.291665 
	C41.289066,9.699935 33.601273,9.742861 25.450066,9.867850 
z"
          />
          <path
            fill="#1D1605"
            opacity="1.000000"
            stroke="none"
            d="
M45.987564,67.319092 
	C45.824444,62.865437 45.824444,58.726231 45.824444,54.325245 
	C47.482407,54.551994 49.081703,54.770721 49.827553,54.872726 
	C49.596664,57.377739 49.392757,59.590023 49.585327,62.244179 
	C49.957893,63.113415 49.933975,63.540783 49.910057,63.968147 
	C48.656933,65.189949 47.403809,66.411743 45.987564,67.319092 
z"
          />
          <path
            fill="#E3B605"
            opacity="1.000000"
            stroke="none"
            d="
M34.118958,63.905846 
	C34.269184,63.121967 34.821316,62.367313 35.702763,61.162548 
	C32.748165,61.367237 30.360706,61.532635 27.973249,61.698032 
	C27.940304,61.186829 27.907358,60.675621 27.874413,60.164417 
	C30.512505,60.022427 33.150597,59.880432 36.362274,59.707569 
	C35.806297,58.215996 35.373669,57.055332 34.801331,55.522736 
	C35.116283,55.104847 35.570946,55.058895 36.467896,55.440086 
	C36.931244,58.587391 36.952297,61.307556 36.973351,64.027718 
	C36.973351,64.027718 36.966614,64.156906 36.938484,64.216614 
	C36.113857,64.162575 35.317356,64.048828 34.118958,63.905846 
z"
          />
          <path
            fill="#261C05"
            opacity="1.000000"
            stroke="none"
            d="
M87.032913,63.334824 
	C88.843887,63.173862 90.724243,63.352753 92.604607,63.531647 
	C92.565529,63.658916 92.555450,63.808048 92.480110,63.907982 
	C92.383492,64.036156 92.234383,64.124771 91.832932,64.493240 
	C90.072754,64.395584 88.587524,64.035133 87.032913,63.334824 
z"
          />
          <path
            fill="#F2BE08"
            opacity="1.000000"
            stroke="none"
            d="
M50.294308,63.979393 
	C49.933975,63.540783 49.957893,63.113415 49.913940,62.371437 
	C50.856709,62.470379 51.867352,62.883942 52.930473,63.653614 
	C52.214825,64.003365 51.446693,63.997005 50.294308,63.979393 
z"
          />
          <path
            fill="#F4BC08"
            opacity="1.000000"
            stroke="none"
            d="
M94.111969,55.707890 
	C93.625969,55.467106 93.227554,54.982761 92.927277,54.249802 
	C93.416786,54.488903 93.808174,54.976616 94.111969,55.707890 
z"
          />
          <path
            fill="#FAB503"
            opacity="1.000000"
            stroke="none"
            d="
M100.525452,69.550766 
	C100.470421,69.584290 100.580490,69.517250 100.525452,69.550766 
z"
          />
          <path
            fill="#FFE607"
            opacity="1.000000"
            stroke="none"
            d="
M41.106197,63.972248 
	C40.913792,63.980953 40.721386,63.989658 40.249832,63.530453 
	C39.975597,59.624393 40.187298,56.166023 39.854328,52.760921 
	C39.759411,51.790287 38.082516,50.974354 37.131058,50.087479 
	C36.222801,49.864277 35.314541,49.641071 34.229542,49.110153 
	C39.039948,48.832142 44.027100,48.861839 49.474579,48.863358 
	C48.324482,49.523621 46.620213,50.060223 45.146996,50.970688 
	C44.502621,51.368919 44.330708,52.531643 43.543182,53.655190 
	C42.466755,54.743626 41.295719,55.472935 41.208908,56.314133 
	C40.947895,58.843433 41.109470,61.416348 41.106197,63.972248 
z"
          />
          <path
            fill="#0C0803"
            opacity="1.000000"
            stroke="none"
            d="
M37.048172,50.489170 
	C38.082516,50.974354 39.759411,51.790287 39.854328,52.760921 
	C40.187298,56.166023 39.975597,59.624393 39.960957,63.526356 
	C39.204426,64.052513 38.457626,64.114845 37.342087,64.102448 
	C36.952297,61.307556 36.931244,58.587391 36.810242,55.424828 
	C36.795292,53.618572 36.880287,52.254715 37.048172,50.489170 
z"
          />
          <path
            fill="#EEC207"
            opacity="1.000000"
            stroke="none"
            d="
M80.982773,48.572044 
	C80.150047,48.987568 79.371384,48.977455 78.204010,48.946671 
	C76.901337,44.273560 76.782349,39.254005 74.850792,35.071522 
	C72.902817,30.853485 69.568176,27.011374 66.077576,23.846663 
	C62.770451,20.848288 58.473347,18.941824 54.856785,16.203802 
	C67.965202,16.466869 80.144798,31.687160 80.982773,48.572044 
z"
          />
          <path
            fill="#EBC007"
            opacity="1.000000"
            stroke="none"
            d="
M74.060837,48.574780 
	C73.214203,48.989292 72.419739,48.980747 71.228592,48.952408 
	C70.944908,32.330486 60.135437,25.695635 44.497871,22.519356 
	C57.923336,17.798668 73.068604,32.021900 74.060837,48.574780 
z"
          />
          <path
            fill="#E5BE07"
            opacity="1.000000"
            stroke="none"
            d="
M67.298096,48.440689 
	C66.503616,48.887993 65.625755,48.931427 64.308777,48.957680 
	C64.532585,36.468937 56.069847,32.061260 44.425449,29.581512 
	C55.150707,25.515751 66.020912,35.394402 67.298096,48.440689 
z"
          />
          <path
            fill="#EEC106"
            opacity="1.000000"
            stroke="none"
            d="
M60.370808,48.449993 
	C59.556854,48.876282 58.651878,48.915550 57.294006,48.921654 
	C58.530537,40.813557 51.305878,39.279427 45.671040,35.744457 
	C53.896503,34.647560 59.009815,39.484154 60.370808,48.449993 
z"
          />
          <path
            fill="#EEC106"
            opacity="1.000000"
            stroke="none"
            d="
M56.575253,48.800755 
	C56.064594,49.021221 55.180859,49.199383 54.125420,49.096931 
	C54.703205,48.797031 55.452686,48.777740 56.575253,48.800755 
z"
          />
          <path
            fill="#EEC106"
            opacity="1.000000"
            stroke="none"
            d="
M53.145592,47.692963 
	C52.790852,47.514610 52.434944,46.998463 52.074272,46.149536 
	C52.427814,46.329563 52.786121,46.842361 53.145592,47.692963 
z"
          />
          <path
            fill="#1E1605"
            opacity="1.000000"
            stroke="none"
            d="
M64.923027,55.387947 
	C64.396461,56.043282 63.923317,56.338604 63.230591,56.812309 
	C62.022911,59.105431 61.034813,61.220169 59.817333,63.825829 
	C59.524162,63.603386 58.660660,62.948200 57.399223,61.798805 
	C56.952248,60.869175 56.903202,60.433758 56.854160,59.998337 
	C58.130455,54.754227 60.562794,53.265762 64.923027,55.387947 
z"
          />
          <path
            fill="#151003"
            opacity="1.000000"
            stroke="none"
            d="
M41.550457,64.048447 
	C41.109470,61.416348 40.947895,58.843433 41.208908,56.314133 
	C41.295719,55.472935 42.466755,54.743626 43.571602,53.960510 
	C44.094448,56.594944 44.370117,59.245827 44.172241,61.860882 
	C44.111336,62.665783 42.756870,63.372807 41.550457,64.048447 
z"
          />
          <path
            fill="#251B04"
            opacity="1.000000"
            stroke="none"
            d="
M73.964226,57.925735 
	C73.724449,57.450787 73.484680,56.975842 73.326225,56.154289 
	C73.664490,55.650936 73.848534,55.432705 73.959694,55.153000 
	C73.959694,55.153000 74.333626,55.120129 74.521126,55.126774 
	C75.165695,55.878387 75.622772,56.623356 76.085434,57.981274 
	C76.043251,59.016018 75.995491,59.437813 75.624725,59.889961 
	C74.872139,59.877907 74.442558,59.835495 74.006485,59.481781 
	C73.988068,58.755566 73.976143,58.340652 73.964226,57.925735 
z"
          />
          <path
            fill="#080605"
            opacity="1.000000"
            stroke="none"
            d="
M72.909515,54.645813 
	C71.524948,54.957840 69.994415,54.904308 68.272156,54.495441 
	C69.641464,54.186821 71.202499,54.233540 72.909515,54.645813 
z"
          />
          <path
            fill="#F2BE08"
            opacity="1.000000"
            stroke="none"
            d="
M56.560722,60.049309 
	C56.903202,60.433758 56.952248,60.869175 57.067066,61.627102 
	C56.844318,61.333168 56.555801,60.716724 56.560722,60.049309 
z"
          />
          <path
            fill="#080605"
            opacity="1.000000"
            stroke="none"
            d="
M73.736519,54.982712 
	C73.848534,55.432705 73.664490,55.650936 73.211807,55.901875 
	C72.867401,55.830109 72.718735,55.664154 72.771515,55.231499 
	C73.153091,54.914001 73.333221,54.863213 73.736519,54.982712 
z"
          />
          <path
            fill="#F4BC08"
            opacity="1.000000"
            stroke="none"
            d="
M75.947723,59.859604 
	C75.995491,59.437813 76.043251,59.016018 76.196991,58.293900 
	C76.727898,58.004219 77.152832,58.014870 77.896454,58.050522 
	C77.733467,59.085587 77.251801,60.095642 76.376556,60.794800 
	C75.971230,60.275806 75.959480,60.067707 75.947723,59.859604 
z"
          />
          <path
            fill="#F4BC08"
            opacity="1.000000"
            stroke="none"
            d="
M88.999847,55.000076 
	C89.509911,55.301594 90.020134,55.603035 90.530350,55.904476 
	C90.349533,56.115059 90.168724,56.325638 89.987907,56.536224 
	C89.683563,56.213348 89.379219,55.890476 89.037590,55.283726 
	C89.000305,54.999847 89.000000,55.000000 88.999847,55.000076 
z"
          />
          <path
            fill="#322506"
            opacity="1.000000"
            stroke="none"
            d="
M73.523674,57.990383 
	C73.976143,58.340652 73.988068,58.755566 73.594109,59.558563 
	C71.793037,60.004234 70.397850,60.061829 69.002655,60.119423 
	C67.972588,59.944225 66.942513,59.769035 65.912445,59.593842 
	C65.914177,59.080906 65.915901,58.567966 65.917633,58.055031 
	C68.306129,58.055031 70.694626,58.055031 73.523674,57.990383 
z"
          />
          <path
            fill="#EEC907"
            opacity="1.000000"
            stroke="none"
            d="
M69.065796,60.454140 
	C70.397850,60.061829 71.793037,60.004234 73.600601,59.869865 
	C74.442558,59.835495 74.872139,59.877907 75.624725,59.889961 
	C75.959480,60.067707 75.971230,60.275806 75.991203,60.796509 
	C75.130318,61.306553 74.261208,61.503994 73.067230,61.826080 
	C71.537888,61.563435 70.333412,61.176147 69.065796,60.454140 
z"
          />{' '}
        </g>
      </svg>
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  // Render as external link
  return (
    <a
      href={APP_URL}
      target="_blank"
      rel="noopener noreferrer"
      style={{ display: 'block', width: '100%', height: '100%' }}
    >
      {logo}
    </a>
  );
}
